@if (initialized && whatsAppUrl) {
  <div class="text-center mb-4">
    <div class="mb-4">
      <p-button styleClass="w-5rem" icon="pi pi-whatsapp p-button-icon text-4xl p-1" severity="success" (click)="openWhatsApp()"></p-button>
    </div>
    <div class="text-color text-2xl font-semibold mb-2">Nur eine WhatsApp-Nachricht entfernt!</div>
    <span class="text-color-secondary text-base">Scanne den QR-Code, um WhatsApp einfach zu starten.</span>
  </div>
  <div class="grid">
    <div class="col-12 text-center">
      <qrcode [qrdata]="whatsAppUrl" [width]="180"></qrcode>
    </div>

    <p-divider class="w-20rem m-auto" align="center">
      <b>ODER</b>
    </p-divider>

    <div class="col-12 text-center">
      <a [href]="whatsAppUrl" target="_blank">Web WhatsApp starten</a>
    </div>

  </div>
}
